import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getSelectedTerminalCalls } from '../../data/selectedterminalcalls';
import { normalizeIds } from '../utils/normalize';

export const useVoyageTerminalCalls = (voyage: any) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!voyage?.terminalCalls) return;

    const voyageTerminalCallIds = normalizeIds(voyage.terminalCalls);

    dispatch(getSelectedTerminalCalls(voyageTerminalCallIds));
  }, [voyage, dispatch]);
};